import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import moment from 'moment';
import {
  setCurrentMonth,
  setNextMonthBooking,
  setPreviousMonthBooking
} from '../../data/booking/bookingActions';
import Day from './Day';

class CalendarHeader extends React.Component {
  constructor(props) {
    super(props);

    // start date project
    this.startDateProject = moment(this.props.start_date);
    // end date project
    this.endDateProject = moment(this.props.end_date);

    // range date
    this.dateRangeProject = [this.startDateProject, this.endDateProject];

    this.state = {
      previousDisabled: this.props.disableHistory,
      month: this.startDateProject.clone(),
      selected: this.startDateProject
    };

    this.props.dispatch(setCurrentMonth(this.startDateProject.clone()));

    this.handleHeaderCalendar = this.handleHeaderCalendar.bind(this);
    this.handlePrevious = this.handlePrevious.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleHeaderCalendar = this.handleHeaderCalendar.bind(this);
    this.updatePreviousState = this.updatePreviousState.bind(this);
  }

  render() {
    return (
      <div className="booking__calendar-header">
        <div className="booking__calendar-header-content">
          <div className="booking__calendar-header-table table_wrapper">
            <Table celled className="table booking__calendar_table booking__calendar_table-days">
              <Table.Body>
                <Table.Row>
                  <Table.Cell key="NextP" className="cell-prev-month static">
                    <div className="prev-month">
                      <button
                        className="button transparent"
                        disabled={this.state.previousDisabled}
                        onClick={this.handlePrevious}
                      >
                        <i className="icon-play3 icon prev-month" />
                      </button>
                    </div>
                  </Table.Cell>
                  {this.props.currentMonth && this.renderMonth()}

                  <Table.Cell key="NextM" className="cell-next-month">
                    <div className="next-month">
                      <button className="button transparent" onClick={this.handleNext}>
                        <i className="icon-play3 icon" />
                      </button>
                    </div>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </div>
        </div>
      </div>
    );
  }

  renderMonth() {
    const days = [];
    let date = this.props.currentMonth
      .clone()
      .add('w' - 1)
      .startOf('isoWeek');
    for (let i = 0; i < 7 * 7; i++) {
      days.push(
        <Day
          key={date.toString()}
          date={date}
          isBooked={false}
          showDay
          clickHandler={this.handleHeaderCalendar}
        />
      );

      date = date.clone();
      date.add(1, 'd');
    }

    return days;
  }

  handlePrevious() {
    this.props.dispatch(setPreviousMonthBooking());
    this.updatePreviousState();
  }

  handleNext() {
    this.props.dispatch(setNextMonthBooking());
    this.updatePreviousState();
  }

  // Booking room : click on date to book room
  handleHeaderCalendar(day, id) {}

  updatePreviousState() {
    if (this.props.disableHistory) {
      const previousDisabled =
        this.props.currentMonth.isSame(moment(), 'month') &&
        this.props.currentMonth.isSame(moment(), 'year');
      this.setState({ previousDisabled });
    }
  }
}

CalendarHeader.defaultProps = {};

export default connect(state => ({
  project: state.projects.single.active,
  currentMonth: state.projects.single.booking.currentMonth,
  start_date: state.projects.single.active.start_date,
  end_date: state.projects.single.active.end_date
}))(CalendarHeader);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/booking/CalendarHeader.js